import store from '@/state/store';
import { handleError } from '@/actions/common';
import { AuthenticationStatus } from '@/contracts';
import { checkEmailVerificationClaim, getProfile } from '@/api/profile';
import authenticationSlice from '@/state/authentication.slice';

export default async function (): Promise<void> {
  const { authentication } = store.getState();
  if (authentication.status !== AuthenticationStatus.AUTHENTICATED) return;
  try {
    const check = await checkEmailVerificationClaim();
    if (!check) {
      const p = await getProfile();
      store.dispatch(authenticationSlice.actions.finishEmailVerification(p.email));
    }
  } catch (error) {
    handleError(error);
  }
};